import { defineCollection } from "@rebasepro/cms-types";
import playersCollection from "./players";
import { personName } from "../people";
import type { CollectionConfig } from "@rebasepro/types";

// Solo progress kept with an account (songbuzz_solo_save): level, fans, the shelf, so it follows the player to any
// device. `rev` goes up with every save. backend/functions/songbuzz.ts creates and writes it.
const soloSavesCollection = defineCollection({
    name: "Solo progress",
    singularName: "Solo progress",
    slug: "solo_saves",
    table: "songbuzz_solo_save",
    description: "Each signed-in player's Solo save: level, scores, Daily Gig, achievements, party counts and look.",
    securityRules: [{ operation: "select", roles: ["admin"] }],
    properties: {
        who: { name: "Account", type: "string", isId: "manual", admin: { readOnly: true } },
        player: {
            name: "Player", type: "relation",
            relation: { kind: "via", cardinality: "one", target: (): CollectionConfig => playersCollection, relationName: "player", joinPath: [{ table: "songbuzz_players", on: { from: "who", to: "id" } }] },
            admin: { readOnly: true },
        },
        // the save as the game wrote it (SyncedMeta in src/core/solo-core.ts), shown as levels, scores and achievements
        meta: {
            name: "Progress", type: "map", keyValue: true, properties: {}, columnType: "jsonb", validation: { required: true },
            admin: { readOnly: true, span: 4, Preview: "../../admin/src/previews/SoloSave" },
        },
        rev: { name: "Times saved", type: "number", columnType: "integer", defaultValue: 1, validation: { required: true }, admin: { readOnly: true } },
        at: { name: "Last saved", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
    },
    admin: {
        icon: "Save",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["at", "desc"],
        listProperties: ["rev", "at"],
        form: {
            sections: [
                { key: "save", properties: ["player", "meta"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["who", "rev", "at"] },
            ],
        },
        display: {
            title: async ({ entity, context }) => personName(context, entity.values.who),
            // the save's headline numbers: the list can't show the Progress card itself
            subtitle: ({ entity }) => {
                const m = (entity.values.meta ?? {}) as { fans?: number; runs?: number; songs?: number; daily?: { best?: number } };
                return [`${m.fans ?? 0} fans`, `${m.runs ?? 0} tours`, `${m.songs ?? 0} songs named`, m.daily?.best ? `best Daily Gig ${m.daily.best}` : ""].filter(Boolean).join(" · ");
            },
            date: "at",
        },
    },
});

export default soloSavesCollection;
